const getters = {
  user: state => state.common.user,
  routes: state => state.common.routes,
  menuRoutes: state => {
    function filterRoutes (routes) {
      return routes.filter(r => {
        if (r.show) {
          if (r.children) r.children = filterRoutes(r.children)
          return true
        }
        return false
      })
    }
    if (state.common.routes[0]) return filterRoutes(state.common.routes[0].children)
    else return []
  },
  isCollapse: state => state.common.isCollapse
}

export default getters
